const unpauseTypes = {
  unpause5: 'unpause5', // $5 off
  unpause50: 'unpause50', // 50% off
  unpausefree: 'unpausefree', // 1 month free
  unpausefreecase: 'unpausefreecase', // free case
} as const


export type UnpauseTypes = typeof unpauseTypes[keyof typeof unpauseTypes]

export default unpauseTypes
